import { EActionTypes } from './actionTypes';

export const setPage = (payload: number) => ({
  type: EActionTypes.setPage,
  payload,
});
